import React from "react"
import { useAppSelector } from "../../../../../../app/hooks"
import { Alert, Button, Snackbar } from "@mui/material";
import { PostAdd } from "@mui/icons-material";
import { VarianceDetailsValid } from "../../../../specs/VarianceDetailsValid";
import { VariancePostCommand } from "../../../../../../services/varianceService/commands/VariancePostCommand";
import { useVariancePendingMutation, useVarianceSaveMutation } from "../../../../../../services/varianceService/variance-api";
import { useMyProfileQuery } from "../../../../../../services/profileService/profile-api";
import { VariancePendingPostCommand } from "../../../../../../services/varianceService/commands/VariancePendingPostCommand";
import { useNavigate } from "react-router";

type ownProps ={
    setNotify:Function;
    setMessage:Function;}

function VarianceSubmitForApprovalBtn(props:ownProps){
    const profile = useMyProfileQuery();
    const variance = useAppSelector((state)=>state.varianceRequest.varianceRequest);
    const [incidentSave] = useVarianceSaveMutation();
    const [saveStatus, result] = useVariancePendingMutation();
    const [isValid, setIsValid] = React.useState(true);
    const command = new VariancePendingPostCommand(variance?.id, profile.data?.identity!, profile.data?.email!);
    const navigate = useNavigate();
    const handleSave=async ()=>{
        if(!new VarianceDetailsValid().IsSatisfiedBy(variance)){
            setIsValid(false);
            return;
        }
        
        setIsValid(true);
        try {
            await incidentSave(new VariancePostCommand(variance)).unwrap();
            await saveStatus(command).unwrap();
            props.setNotify(true);
            props.setMessage('Incident Submitted for Approval');
            setTimeout(() => navigate(-1), 3000);
        } catch (error) {
            console.error('Failed to submit incident:', error);
        }
    }
    return <React.Fragment>
        <Button variant='outlined' color='success' startIcon={<PostAdd/>}
            onClick={()=>{handleSave()}}>{result.isLoading?'Submitting':'Submit'}</Button>

        <Snackbar open={result.isError}>
            <Alert color='error'>{'An error has occured: ' + JSON.stringify(result.error)}</Alert>
        </Snackbar>
        <Snackbar open={!isValid} onClose={()=>setIsValid(true)} color='error' autoHideDuration={6000}>
            <Alert severity='error'>{'Invalid Incident: Confirm Details'}</Alert>
        </Snackbar>
        
    </React.Fragment>
}


export {VarianceSubmitForApprovalBtn}